import "@hotwired/turbo-rails";
import { createApp } from "vue";
import { registerComponents } from "./components";
import "./controllers";

const mountVue = () => {
  const mountPoint = document.getElementById("vue-app");

  if (!mountPoint) return; // Mounting point not found
  if (mountPoint.__vue_app__) return; // Vue app already mounted

  const app = createApp({});
  registerComponents(app);
  app.mount("#vue-app");
};

document.addEventListener("turbo:render", () => mountVue());
document.addEventListener("DOMContentLoaded", () => mountVue());
